import { range } from "lib/helpers";

export const GREY = "#E1E1E1";
export const GREEN = "#6FCF97";
export const WHITE = "#FFFFFF";
export const LIGHT_GREY = "#F8F8F8";
export const RED = "#EB5757";
export const YELLOW = "#F2C94C";
export const NO_OP = (): undefined => undefined;
export const DUMMY_OVERVIEW_ROW = {
  userId: 0,
  orderId: 0,
  offerId: 0,
  amount: 0,
  multiple: 0,
  status: "open",
  lastUpdate: "",
};
export const OVERVIEW_MOCKED_DATA = Object.assign(
  {},
  ...range(10).map(x => ({ [`${x}`]: DUMMY_OVERVIEW_ROW })),
);

export const SITE_TITLE = "Royalty Exchange";
export const RX_PHONE_NUMBER = "+1-800-718-2269";

export const SELLER_ACCOUNT_CREATION_URL = "/seller/create-account/";
export const ADD_ASSET_URL = "/seller/add-asset";
export const ASSET_DETAIL_URL = "/orderbook/asset-detail/";
export const BUYER_LOGIN_URL = "/accounts/login";
export const BUYER_SIGNUP_URL = "/accounts/signup";
export const BID_OR_BUY_URL = "/bid_or_buy_now";

export const HOMEPAGE_URL = "https://www.royaltyexchange.com";
export const ABOUT_ROYALTY_EXCHANGE_URL = `${HOMEPAGE_URL}/about-royalty-exchange`;
export const ACCOUNTING_AGREEMENT_URL = `${HOMEPAGE_URL}/accounting-agreement-terms`;
export const ALL_ACCESS_INVESTOR_URL = `${HOMEPAGE_URL}/all-access-investor`;
export const ALL_ACCESS_MEMBERSHIP_URL = `${HOMEPAGE_URL}/all-access-membership`;
export const BLOG_MUSIC_ROYALTIES_URL = `${HOMEPAGE_URL}/blog/music-royalties`;
export const BLOG_WHAT_IS_DOLLAR_AGE_URL = `${HOMEPAGE_URL}/blog/what-is-dollar-age`;
export const CONTACT_US_FORM_URL = `${HOMEPAGE_URL}/contact-us`;
export const INSTANT_OFFER_URL = `${HOMEPAGE_URL}/instant-offer`;
export const PRIVACY_POLICY_URL = `${HOMEPAGE_URL}/privacy-policy`;
export const TERMS_AND_CONDITIONS_URL = `${HOMEPAGE_URL}/terms-and-conditions`;
export const TERMS_OF_USE_URL = `${HOMEPAGE_URL}/terms-of-use`;
export const TROLLEY_PAYMENT_PORTAL_URL =
  "https://royaltyexchange.portal.trolley.com/";

export const INVESTOR_VERIFICATION_URL =
  "https://hs.royaltyexchange.com/investor-verification-questionnaire";

export const getVPURL = () => {
  return import.meta.env.DEV ? "http://localhost:3002/" : "/";
};

export const VP_URL = `${getVPURL()}vp/`;

export const DASHED_DATE_FORMAT = "MM-DD-YYYY";

export const FIXED_TERM = ["life_of_rights", "fixed_return"];

export const EMPTY_VALUE_PLACEHOLDER = "—"; // em dash
